export const EMAIL_REQUIRED = "Please enter the email";
export const YES = "Yes";
export const PASSWORD_REQUIRED = "Please enter the password";
export const EMAIL_PASSWORD_REQUIRED = "Please enter email and password";
export const FIRST_NAME_REQUIRED = "Please enter First Name";
export const PHOTO_REQUIRED = "Please upload your photo";
export const FINGERPRINT_REQUIRED = "Please verfiy your fingerprint";
export const PHOTO_CAPTURE = "Please capture your photo";
export const FIRST_NAME_LIMIT_ERROR = "First Name should be less than 30 characters";
export const LAST_NAME_REQUIRED = "Please enter Last Name";
export const LAST_NAME_LIMIT_ERROR = "Last Name should be less than 30 characters";
export const CONFIRM_PASSWORD_REQUIRED = "Please confirm your password";
export const PASSWORD_CONFIRM_PASSWORD_MATCH = "Password and confirm password do not match";
export const OLD_PASSWORD_REQUIRED = "Please enter Old Password";
export const NEW_PASSWORD_REQUIRED = "Please enter New Password";
export const SAME_OLD_NEW_PASS = "Old Password and New Password cannot be the same";
export const NEW_CONFIRM_PASSWORD_REQUIRED = "Please confirm your Password";
export const INVALID_PASSWORD = "Please enter password between 6 to 12 characters";
export const OTP_REQUIRED = "Please enter OTP to proceed";
export const VALID_OTP = "Please enter 4 Digit OTP to proceed";
export const OTP_SENT_SUCCESS = "Email Validation OTP has been sent successfully";
export const OTP_SENT_FAILURE = "Please retry after 30 seconds.";
export const SOMETHING_WENT_WRONG = "We seem to have hit a snag. Please retry in a while.";
export const NAME_REQUIRED = (name = "") => {
  return `Please enter the ${name ? name + " " : ""}Name`;
};
export const LATLNG_REQUIRED = "Please enter the Lat/Lng";
export const LATLNG_INVALID = "Please enter correct Lat/Lng";
export const IMAGE_REQUIRED = "Please add an Image";
export const COLOR_REQUIRED = "Please select primary color";
export const HOSPITAL_SERVICES_REQUIRED = "Please enter Services";
export const PHONE_NUMBER_REQUIRED = "Please enter the phone number";
export const ALTERNATE_PHONE_NUMBER_REQUIRED = "Please enter the alternate phone number";
export const PHONE_NUMBER_INCORRECT = "Please enter correct phone number";
export const ALTERNATE_PHONE_NUMBER_INCORRECT = "Please enter correct alternate phone number";
export const MESSAGE_REQUIRED = "Please enter the message";
export const INCORRECT_EMAIL = "The email must be a valid email address";
export const INCOMPLETE_PROFILE_ERROR = "Please complete your profile!";
export const MIN_MAX_EXPERIENCE_ERROR =
  "Maximum experience should be greater than minimum experience";
export const TOTAL_POSITIONS_REQUIRED_ERROR = "Please enter number of positions";
export const TOTAL_POSITIONS_LIMIT_ERROR = "Number of positions must be greater than 0";
export const USER_REGISTRATION_ISSUE = "Issue with User Registration";
export const VALID_LINK = "Please enter a valid link";
export const BUTTON_TEXT_OK = "OK";
export const DATEPICKER_PLACEHOLDER = "DD/MM/YYYY";
export const LOGIN_FAIL =
  "Unable to find user with this Email and Password, Please create an account.";
export const LOGIN_SUCCESS = "Logged In Successfully";
export const RESET_PASSWORD_SUCCESS = "Password Reset Successfully";
export const RESET_PASSWORD_FAIL = "Password Reset Failed";
export const BROWSER_STORAGE_ERROR =
  "Your web browser does not support storing settings locally. Some settings may not save or some features may not work properly for you.";
export const MEDICINE_NAME_REQUIRED = "Please add Medicine Name";
export const MEDICINE_CATEGORY_NAME_REQUIRED = "Please add Medicine Category Name";
export const INVENTORY_CATEGORY_NAME_REQUIRED = "Please add Inventory Category Name";
export const INVENTORY_NAME_REQUIRED = "Please add Inventory Name";
export const MEDICINE_NAME_LENGTH = "Medicine Name should be at least 3 characters long";
export const MEDICINE_CATEGORY_LENGTH =
  "Medicine Category Name should be at least 3 characters long";
export const INVENTORY_CATEGORY_LENGTH =
  "Inventory Category Name should be at least 3 characters long";
export const INVENTORY_LENGTH = "Inventory Name should be at least 3 characters long";
export const SERVICE_NAME_LENGTH = "Service Name should be at least 3 characters long";
export const DIAGNOSIS_NAME_LENGTH = "Diagnosis Name should be at least 3 characters long";
export const MEDICINE_TYPE_REQUIRED = "Please add Medicine Type";
export const SERVICE_TYPE_REQUIRED = "Please add Service Type";
export const RESTRICTED_IPD = "Cannot move to IPD. The bill has been cancelled.";
export const MEDICINE_DESC_REQUIRED = "Please add Medicine Description";
export const SERVICE_DESC_REQUIRED = "Please add Service Description";
export const DESC_REQUIRED = "Please add Description";
export const MEDICINE_DESC_LENGTH = "Medicine Description should be at least 10 characters long";
export const SERVICE_DESC_LENGTH = "Service Description should be at least 10 characters long";
export const BILL_DATE_REQUIRED = "Please enter Bill Date";
export const EXPENSE_DATE_REQUIRED = "Please enter Expense Date";
export const BILL_NO_REQUIRED = "Please enter Bill Number";
export const BILL_NO_LENGTH = "Please enter 14 Digit Bill Number";
export const SUPPLIER_REQUIRED = "Please add Supplier Name";
export const PURCHASE_PRICE_REQUIRED = "Please enter Purchase Price";
export const SALE_PRICE_REQUIRED = "Please enter Sale Price";
export const QUANTITY_REQUIRED = "Please enter Quantity";
export const COMMENT_REQUIRED = "Please enter Comment";
export const DATE_REQUIRED = "Please select Date";
export const FREQ_REQUIRED = "Please enter Frequency";
export const DAY_NIGHT_SCHEDULE_REQUIRED = "Please check Day or Night schedule";
export const PRESCRIPTION_APPLICATION_REQUIRED = "Please select prescription application";
export const EXPIRY_DATE_REQUIRED = "Please enter Expiry Date";
export const GST_REQUIRED = "Please enter GST Percentage";
export const SGST_REQUIRED = "Please enter SGST";
export const CGST_REQUIRED = "Please enter CGST";
export const GST_TYPE_REQUIRED = "Please add GST Type";
export const DISCOUNT_REQUIRED = "Please enter Discount value";
export const NET_AMOUNT_REQUIRED = "Please enter Net Amount";
export const PAYMODE_REQUIRED = "Please add Pay Mode";
export const PATIENT_FOUND = "Patient found with given details and the data has been retrieved!";
export const PATIENT_NOT_FOUND =
  "No Patient found, please fill data manually, or try with different details!";
export const PATIENT_ID_FOUND = "Patient found!";
export const PATIENT_ID_NOT_FOUND = "No Patient found!";
export const PATIENT_PHOTO_REQUIRED = "Please add profile photo";
export const WEBCAM_ERROR = "Error accessing Webcam. Please allow access or try again!";
export const PATIENT_AADHAAR_REQUIRED = "Please enter Aadhaar Number";
export const PATIENT_AADHAAR_LENGTH = "Aadhaar Number should be of 12 digits";
export const PATIENT_ONLINE_ID_REQUIRED =
  "Please enter an Online ID containing 8 to 12 characters.";
export const PATIENT_FILE_NO_REQUIRED = "Please enter File Number";
export const PATIENT_PNDT_REQUIRED = "Please enter PNDT";
export const PATIENT_CO_REQUIRED = `Please enter Father/Spouse Name`;
export const DOB_REQUIRED = "Please enter Date of Birth";
export const AGE_REQUIRED = "Please enter Age";
export const GENDER_REQUIRED = "Please select Gender";
export const VISIT_DATE_REQUIRED = "Please select Visit Date";
export const NEXT_VISIT_DATE_REQUIRED = "Please select Next Visit Date";
export const NEXT_VISIT_TIME_REQUIRED = "Please select visit time";
export const DEPARTMENT_REQUIRED = "Please select Department.";
export const DOCTOR_REQUIRED = "Please add Doctor Name";
export const FORM_NATIVE_VALIDATION_FAILED = "Please fill in all required fields correctly.";
export const ADDRESS_REQUIRED = "Please enter Address";
export const DAYS_REQUIRED = "Please enter Days";
export const CITY_REQUIRED = "Please enter City";
export const STATE_REQUIRED = "Please enter State";
export const PRESCRIPTION_DESCRIPTION_REQUIRED = "Please enter Prescription Instructions";
export const TYPING_MEDICINE_REQUIRED = "Please write  medicine";
export const SELECT_MEDICINE_REQUIRED = "Please add  medicine";
export const WRITE_SELECT = "Please enter or select medicine";
export const VITALS_REQUIRED = "Please enter Vitals";
export const BP_REQUIRED = "Please enter BP/SO2";
export const HEIGHT_WEIGHT_REQUIRED = "Please enter HEIGHT/WEIGHT";
export const HISTORY_REQUIRED = "Please enter History";
export const DIAGNOSIS_REQUIRED = "Please enter Diagnosis";
export const REMARKS_REQUIRED = "Please enter Remarks";
export const Total_REQUIRED = "Please enter Total";
export const TOTAL_PAYABLE_REQUIRED = "Please enter Total Payable amount";
export const TOTAL_UNITS_REQUIRED = "Please enter Total Units";
export const MEDICINE_ALREADY_ADDED = "Medicine already added";
export const SERVICE_ALREADY_ADDED = "Service already added";
export const SERVICE_REQUIRED = "Please select a Service";
export const AVAILABLE_MEDICINE_QTY = "Total available Medicine Quantity: ";
export const NO_DATA_FOUND = "No data found";
export const ADD_SOME_DATA = "Please add some data to continue";
export const BATCH_NUMBER = "Please add Batch Number";
export const UNIT_PRICE = "Please add Unit Price";
export const NOT_ACCESSABLE = "You can't perform this action";
export const PAID_AMT_ERROR = "Paid Amount should not be more than Due Amount";
export const DISCOUNT_AMT_ERROR = "Discount Amount should not be more than Sub Total";
export const DUE_AMOUNT_ZERO = "Due Amount cannot be less than Zero";
export const MAX_AMT_LIMIT_REACHED = `Max ₹5,00,000.00 Amount is allowed`;
export const MAX_STOCK_LIMIT_REACHED = `Max 99,999.00 Inventory is allowed`;
export const MAX_AMT_LIMIT_REACHED_LACKS = `Max ₹9,99,999.00 Amount is allowed`;
export const MAXIMUM_AMT_LIMIT_REACHED = `Max ₹99,99,999.00 Amount is allowed`;
export const MAX_PERCENTAGE_LIMIT_REACHED = `Max 100% is allowed`;
export const MAX_QTY_LIMIT_REACHED = `Max 99,999 Quantity is allowed`;
export const MAX_200_QTY_LIMIT_REACHED = `Max 200 Quantity is allowed`;
export const MAX_999_QTY_LIMIT_REACHED = `Max 999 Quantity is allowed`;
export const MAX_DAYS_LIMIT_REACHED = `Max 90 Days are allowed`;
export const ACTION_NOT_PERFORMABLE = `Cannot perform this action, this medicine's inventory is already in use`;
export const MAX_1024_CHARS = `Max 1024 characters allowed`;
export const MAX_500_CHARS = `Max 500 characters allowed`;
export const MAX_250_CHARS = `Max 250 characters allowed`;
export const MAX_200_CHARS = `Max 200 characters allowed`;
export const MAX_150_CHARS = `Max 150 characters allowed`;
export const MAX_100_CHARS = `Max 100 characters allowed`;
export const MAX_60_CHARS = `Max 60 characters allowed`;
export const MAX_50_CHARS = `Max 50 characters allowed`;
export const MAX_30_CHARS = `Max 30 characters allowed`;
export const MAX_20_CHARS = `Max 20 characters allowed`;
export const MAX_10_CHARS = `Max 10 characters allowed`;
export const MAX_1000_CHARS = `Max 1000 characters allowed`;

export const EDIT_NOT_ALLOWED = "Edit not allowed";
export const EARLY_VISIT_REASON_REQUIRED = "Please fill Early Visit Reason";
export const FOLLOWUP_DATE_REQUIRED = "Please select a follow-up date";
export const minimumLengthRequired = (length) => {
  return `Minimum ${length} characters required`;
};
export const maximumLengthRequired = (length) => {
  return `Maximum ${length} characters required`;
};
export const maximumLengthAllowed = (length) => {
  return `Maximum ${length} characters Allowed`;
};

export const MEDICINE_OUT_OF_STOCK = `No Batch found for selected medicine`;
export const MEDICINE_ORDER_ALREADY_CREATED = `Sold medicine can't be removed from the order. Instead, please handle it as a sale return`;
export const STATUS_REQUIRED = `Please select Status`;
export const ROLE_REQUIRED = `Please select Role`;
export const POC_REQUIRED = `Please Enter POC`;
export const PASSWORD_FIELD_INFO =
  "Leave Password field untouched if you don't want to change Password";
export const PAGE_NOT_ACCESSABLE = "You cannot access this page";
export const SELECT_DATE_RANGE = "Select date range";
export const DOCTOR_TITLE = "Please enter Doctor's Title";
export const DOCTOR_DEGREE = "Please enter Doctor's Degree";
export const ADDITIONAL_INFO = "Please enter Additional Info";
export const SIGNATURE_REQUIRED = "Please upload a signature";
export const USER_REQUIRED = "Please select a User";
export const ENABLE_REQUIRED_CONFIG =
  "Mobile number or File number or Aadhar card or Online atleast 1 field should enable & mandatory";
export const PRODUCT_ID_REQUIRED = "Please enter Product ID";
export const CATEGORY_REQUIRED = "Please select the category";
export const PRODUCT_DETAIL_ID_REQUIRED = "Please enter Product Detail ID";
export const CN_NUMBER_REQUIRED = "Please enter CN Number";
export const CN_AMOUNT_REQUIRED = "Please enter CN Amount";
export const RETURN_DATE_REQUIRED = "Please enter Return Date";
export const POC_NAME_REQUIRED = "Please enter POC Name";
export const POC_NUMBER_REQUIRED = "Please enter POC Number";
export const CN_RX_BY_REQUIRED = "Please select CN Received By";
export const SOLDOUT = "SOLDOUT";
export const AMOUNT_REQUIRED = "Please enter Amount";
export const TOTAL_AMOUNT_REQUIRED = "Please enter Total amount";
export const ROOM_TYPE_REQUIRED = "Please select Room";
export const BED_PRICE_REQUIRED = "Please enter bed charge";
export const PRICE_REQUIRED = "Please enter Price";
export const STAFF_CHARGE_REQUIRED = "Please enter nursing charge";
export const MICS_CHARGE_REQUIRED = "Please enter consultant charge";
export const OXYGEN_STATUS = "Please select Oxygen Status";
export const VACCUM_STATUS = "Please select Vaccum status";
export const ATTACHED_BATH_STATUS = "Please select Attached Bath status";
export const STATUS_BED_REQUIRED = "Please select Status";
export const PATIENT_NOTES_REQUIRED = "Please enter Notes";
export const VISIT_NOTES_REQUIRED = "Summary field is required";
export const BED_TYPE_REQUIRED = "Please select Bed";
export const STAFF_TYPE_REQUIRED = "Please select Staff";
export const ALERT_TYPE_REQUIRED = "Please select Alert";
export const REASON_REQUIRED = "Please enter reason";
export const AMOUNT_VALIDATION = "Entered amount should not be greater than paid amount";
export const DISCHARGE_REASON_REQUIRED = "Please enter discharge reason";
export const DISCHARGE_SUMMARY_REQUIRED = "Please enter discharge summary";
export const ROOM_STATUS_REQUIRED = "Please select room status";
export const USER_REQ = "Please select User";
export const CUSTOM = "CUSTOM";
export const CUSTOM_USERS = "CUSTOM_USERS";
export const HOSPITAL_USERS = "HOSPITAL_USERS";
export const ENABLE_NOTIFICATION = "Please enable email notification";
export const ENABLE_EMAIL_BODY = "Please add content in email body";
export const ADD_ALERT = "Please add alert for";
export const ADD_MEDICINE = "Please add medicine";
export const ADD_TYPE = "Please add type";
export const ADD_QUENTITY = "Please add Quantity in stock";
export const STOCK = "STOCK";
export const EXPIRY = "EXPIRY";
export const BEFORE_DAYS = "BEFORE_DAYS";
export const ADD_EXPIRY = "Please add Expiry Date";
export const ADD_BEFORE_DAYS = "Please add Before Days";
export const ADD_NOTIFY = "Please add notify type";
export const NO_MOBILE_NUMBER = "Mobile number is not saved";
export const GENDER_CONFIRMATION =
  "The selected service is intended for a different gender. Are you sure you want to proceed?";
export const TEMPLATE_ID_REQUIRED = "Please enter the template ID.";
export const SCHEDULED_DATA_TIME = "Scheduled date time required";
export const BROADCAST_NAME_REQUIRED = "Please enter the broadcast name.";
export const DISABLE_MEDICINE_ACTION =
  "This action is locked when the prescription field contains text.";
export const MEDICINE_REQUIRED = "Please select the medicine";
export const POST_ALERT_DAYS = "Please add the number of days for the post alert.";
export const POST_ALERT_HRS = "Please add an alert for post hours.";
export const BOOKING_ALERT_HRS = "Please add an alert for booking hours.";
export const BOOKING_ALERT_MSG = "Please add a booking message.";
export const POST_ALERT_MSG = "Please add a message for the post alert.";
export const ALERT_DAYS_REQUIRED = "Please set alert days.";
export const ALERT_REQUIRED = "Please set time.";
export const ALERT_MNO_REQUIRED =
  "Please provide a mobile number, as alerts are currently turned on.";
export const ALERT_HOURS_REQUIRED = "Please set alert hours.";
export const ALERT_MINUTES_REQUIRED = "Please set alert minutes.";
export const PATIENT_REQUIRED = "Please select patient.";
export const TEMPLATE_NAME_REQUIRED = "Please enter a template name.";
export const TEMPLATE_CATEGORY_REQUIERD = "Please select a category.";
export const TEMPLATE_LANGUAGE_REQUIRED = "Please choose a language.";
export const TEMPLATE_BODY_REQUIRED = "Body content is required. Please enter the content.";
export const TEMPLATE_HEADER_REQUIRED = "Please enter text in header";
export const TEMPLATE_FOOTER_REQUIRED = "Please enter text in footer";
export const NOTIFICATION_PARTNERS_REQUIRED =
  "Please select at least one Notification channel option";
export const APPLICATION_NAME_REQUIRED = "Please enter Application Name";
export const APPLICATION_DESCRIPTION_REQUIRED = "Please add Application Description";
export const APPLICATION_NAME_LENGTH = "Application Name should be at least 3 characters long";
export const APPLICATION_DESC_REQUIRED = "Please add Application Description";
export const APPLICATION_DESC_LENGTH =
  "Application Description should be at least 10 characters long";
export const APPLICATION_TYPE_REQUIRED = "Please add Application Type";
export const RESTRICT_UPDATE_AFTER_DISCHARGE = "You cannot edit or update.";
export const BEFORE_AFTER_IMAGE_REQUIRED = "Please upload before and after images";
export const BEFORE_IMAGE_REQUIRED = "Please upload before image";
export const AFTER_IMAGE_REQUIRED = "Please upload after image";
export const VISIT_CANCELLED = "Visit already cancelled.";
export const TREATMENT_NAME_REQUIRED = "Treatment name is required.";
export const TREATMENT_NAME_LENGTH = "Treatment name must be 3-50 characters.";

export const SERVICE_QTY_REQUIRED = "Please enter quantity.";
export const MIN_SERVICE_QTY_REQUIRED = "Please enter atleast 1 in service quantity.";
export const TREATMENT_COMPLETED_REQUIRED = "Please mark treatment as completed.";

export const MOVE_TO_IPD_WARNING =
  "You are an OPD patient, Please click on Move to IPD to proceed.";
